import { CheckedAddress } from '@sparkdotfi/common-universal'
import { useNavigate } from '@tanstack/react-router'

export interface UseWatchWalletModeActionsResult {
  enableWatchWalletMode: (address: CheckedAddress) => void
  disableWatchWalletMode: () => void
}

export function useWatchWalletModeActions(): UseWatchWalletModeActionsResult {
  const navigate = useNavigate()

  function enableWatchWalletMode(address: CheckedAddress): void {
    void navigate({
      to: '.',
      search: (prev) => ({
        ...prev,
        'watch-address': address,
      }),
    })
  }

  function disableWatchWalletMode(): void {
    void navigate({
      to: '.',
      search: (prev) => ({
        ...prev,
        'watch-address': undefined,
      }),
    })
  }

  return {
    enableWatchWalletMode,
    disableWatchWalletMode,
  }
}
